var map = {
	"./camera.svg": 42,
	"./fibre.svg": 43,
	"./intercom.svg": 44,
	"./light.svg": 45,
	"./outdoor-light.svg": 46,
	"./phone.svg": 47,
	"./plug.svg": 48,
	"./secure-plug.svg": 49,
	"./solar-panel.svg": 50,
	"./speaker.svg": 51,
	"./television.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;